import { IsStrictNumber } from "./types";

// Disallow: "034", "-034.3", ".3", "-.3"
// Allow: "0", "0.3", "-0.3", "3", "-3", "3.14", "-3.14"
export const isStrictNumber: IsStrictNumber = (text) =>
  /^-?(?:0|[1-9]\d*)(?:\.\d+)?$/.test(text);
